import { VerticalField } from "common/ui/field";
import { RadioButtonList } from "common/widgets/radio-button-list";
import {
  SITE_TYPES,
  SiteType,
  translateSiteType,
} from "x/records/list/filter/types";

type Props = {
  value: SiteType;
  onChange: (site: SiteType) => void;
};

export function PartLocationSiteTypeSelector(props: Readonly<Props>) {
  return (
    <div className="x-part-availability-filter">
      <VerticalField
        className="x-select-field"
        label={_("Parts Availability")}
        input={
          <RadioButtonList
            name="siteType"
            display={translateSiteType}
            items={SITE_TYPES}
            value={props.value}
            onChange={props.onChange}
          />
        }
      />
    </div>
  );
}
